import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInjectorService } from '@shared/services/index';
import {defineCustomElements}  from '@ionic/pwa-elements/loader';
import { kzMark, kzPerfObserve } from '@shared/util/kz-perf';
import { guardAndroidKeyboardResizeMode } from '@shared/platform/keyboard-resize-guard';
import { applyDevSafeAreaEmulation } from '@shared/platform/dev-safe-area';
import { kzRaiseResourceTimingBuffer } from '@core/services/shell-warmup.service';

kzMark('main');
kzPerfObserve();
/* kzd-of1 P0-6: the web service worker's warm-up reads resource timing; keep more than the default 250 entries. */
kzRaiseResourceTimingBuffer();
/* kzd r1 §16.47: no Keyboard.getResizeMode bridge call on Android (it is iOS-only; Ionic asks on every sheet open). */
guardAndroidKeyboardResizeMode();
/* kzd r2 D-7b: `?kzInsetTop=24&kzInsetBottom=16` emulates a phone's status bar and gesture bar in a mock or dev
   build's browser (never stage or prod, never on a device). */
applyDevSafeAreaEmulation(!environment.production);


// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

if (environment.production) {
  enableProdMode();
  //https://devdactic.com/building-websites-ionic-4/
  // if (window) {
  //   window.console.log = function() {};
  // }
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));

kzMark('bootstrap:start');
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(moduleRef => {
    kzMark('bootstrap:done');
    AppInjectorService.setInjector(moduleRef.injector);
  })
  .catch(err => console.log(`bootstrapModule ERROR:${err}`));

  
// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
